<phx-search-input
  #searchInputRef
  [phxDropdownFor]="dropdownRef"
  [phxPlaceholder]="phxPlaceholder"
  [phxVisible]="dropdownVisible"
  [phxDropdownClassName]="dropdownClasses"
  [phxDropdownWidth]="phxDropdownWidth"
  [phxDropdownHeight]="phxDropdownHeight"
  [phxTrigger]="null"
  [disabled]="phxDisabled"
  [phxDisabled]="phxDisabled"
  [(ngModel)]="phxUserInput"
  (input)="onInput($event)"
  (focusin)="onFocusIn()"
  (focusout)="onFocusOut($event)"
  (phxOnClearClick)="onClearClick()"
  (keydown)="onKeyDown($event)"
></phx-search-input>

<phx-dropdown #dropdownRef cdkTrapFocus [phxEnableKeyboardNav]="false">
  <div class="phx-typeahead-helper-text" [class.phx-typeahead-helper-text-border]="lastSearches.length > 0" *ngIf="phxUserInput?.length < 2">
    <span>{{ 'Enter at least 2 characters to search' | phxTranslate}}</span>
  </div>
  <phx-menu class="recent-history" *ngIf="!phxLoading && phxShowRecentSearchHistory && phxUserInput?.length === 0 && lastSearches.length > 0">
    <phx-menu-item class="phx-content-heading" [disabled]="true">{{ 'Recent' | phxTranslate }}</phx-menu-item>
    <phx-menu-item #menuItems *ngFor="let search of lastSearches;" (mousedown)="selectSuggestion(search)">
      <div class="phx-item-wrapper">
        <i *ngIf="search.icon" phx-icon [phxIcon]="search?.icon"></i>
        <span class="phx-typeahead-item-content">
          <span class="phx-item-title">{{ search?.name || search?.description || (search?.id) }}</span>
          <div class="phx-item-subtext" *ngIf="(search.subtext || search.description) && search.type !== 'location'">{{ search.subtext || search.description }}</div>
        </span>
        <i class="phx-typeahead-indicator-icon" phx-icon [phxIcon]="enterIcon"></i>
      </div>
    </phx-menu-item>
  </phx-menu>

  <phx-menu *ngIf="phxDefaultOptions?.length > 0">
    <ng-container>
      <phx-menu-item
        #menuItems
        *ngFor="let option of phxDefaultOptions"
        (mousedown)="selectDefaultOption(option)"
      >
        <div class="phx-item-wrapper">
          <span class="phx-typeahead-item-content">
            <span class="phx-item-title">{{ option.label }}</span>
          </span>
          <i class="phx-typeahead-indicator-icon" phx-icon [phxIcon]="enterIcon"></i>
        </div>
      </phx-menu-item>
      <phx-divider
        *ngIf="filteredSuggestions?.length > 0 || shouldShowNoResultsState"
        class="phx-typeahead-item-divider phx-default-options-divider"
        phxMarginX="extra-large"
        phxMarginY="medium"
      ></phx-divider>
    </ng-container>
  </phx-menu>

  <phx-menu *ngIf="(phxUserInput?.length > 1 && !phxHideSearchIndicator) || filteredSuggestions?.length > 0 || shouldShowNoResultsState">
    <ng-container>
      <phx-menu-item
        #menuItems
        *ngIf="!phxHideSearchIndicator"
        class="phx-typeahead-search-entities"
        (mousedown)="searchString()"
      >
        <div class="phx-item-wrapper">
          <i phx-icon [phxIcon]="isCoodinatesIcon ? locationIcon : magnifyingGlassIcon"></i>
          <span class="phx-typeahead-item-content">
            <span class="phx-item-title">
              <strong>{{ phxUserInput }}</strong>
              <span *ngIf="!isCoodinatesIcon"> - {{ 'Search Entities' | phxTranslate }}</span>
            </span>
          </span>
          <i class="phx-typeahead-indicator-icon" phx-icon [phxIcon]="enterIcon"></i>
        </div>
      </phx-menu-item>
      <phx-divider class="phx-typeahead-item-divider phx-search-entities" phxMarginX="extra-large" phxMarginY="medium" *ngIf="!phxHideSearchIndicator"></phx-divider>

      <ng-container *ngIf="!phxLoading && filteredSuggestions?.length > 0; else noResultsFoundTemp">
        <ng-container *ngFor="let item of filteredSuggestions; let isFirst = first">
          <ng-container *ngIf="item?.separator; else customSuggestion">
            <phx-divider class="phx-typeahead-item-divider phx-entity-item" phxMarginX="extra-large" phxMarginY="medium" *ngIf="!isFirst"></phx-divider>
            <phx-menu-item class="phx-content-heading" [disabled]="true">{{ item?.name }}</phx-menu-item>
          </ng-container>

          <ng-template #customSuggestion>
            <phx-menu-item #menuItems (mousedown)="selectSuggestion(item)">
              <div class="phx-item-wrapper">
                <i *ngIf="item.icon" phx-icon [phxIcon]="item?.icon"></i>
                <span class="phx-typeahead-item-content">
                  <span class="phx-item-title" [innerHTML]="highlightMatches(item, phxUserInput)"></span>
                  <div class="phx-item-subtext" *ngIf="(item.subtext || item.description) && item.type !== 'location'" [innerHTML]="highlightSubTextMatches(item, phxUserInput)"></div>
                </span>
                <i class="phx-typeahead-indicator-icon" phx-icon [phxIcon]="enterIcon"></i>
              </div>
            </phx-menu-item>
          </ng-template>
        </ng-container>
      </ng-container>
    </ng-container>
  </phx-menu>

  <div class="phx-typeahead-loader" *ngIf="phxLoading && this.phxUserInput?.length > 1">
    <phx-spinner [phxSize]="'large'"></phx-spinner>
  </div>
</phx-dropdown>

<ng-template #noResultsFoundTemp>
  <div *ngIf="!phxLoading && dataLoaded && phxUserInput?.length > 1 && shouldShowNoResultsState" class="phx-typeahead-no-result">
    <h6>{{ phxNoResultsHeading || 'No results found' | phxTranslate }}</h6>
    <p *ngIf="phxNoResultsMessage">{{ phxNoResultsMessage }}</p>
  </div>
</ng-template>
